import React, { useState } from 'react'
import { t } from 'i18next'
import { isNil } from 'lodash'
import { type TabProps } from '../types'
import { Badge, Icon, IconSize, Tab, TabItem } from '@awell-health/design-system'
import { mapFieldTypeIcon } from './mapFieldTypeIcon'
import { ExpandableContent } from '../../ExpandableContent'

export const SentTab: React.FC<TabProps> = ({ activity, extensionActivityRecord }) => {
  const [activeTab, setActiveTab] = useState<string>('fields')
  if (isNil(extensionActivityRecord)) {
    return (
      <div className="text-center">
        <p className="text-slate-600">{t('error_action_content_not_available')}</p>
      </div>
    )
  }

  const settings = extensionActivityRecord?.settings ?? []
  const fields = extensionActivityRecord?.fields ?? []

  const tabs: TabItem[] = [
    {
      id: 'fields',
      label: 'Fields',
      onClick: () => setActiveTab('fields')
    },
    {
      id: 'settings',
      label: 'Settings',
      onClick: () => setActiveTab('settings')
    }
  ]

  return (
    <div className="flex flex-col gap-4 w-full">
      <div className="text-lg font-medium text-gray-900">Data sent to {activity.indirect_object?.name}</div>
      <Tab variant="default" items={tabs} selected={activeTab} fullWidth={false} size="sm" />
      {activeTab === 'fields' && (
        <div key="fields" className="flex flex-col gap-2 w-full">
          {fields.length > 0 ? (
            fields.map(field => (
              <div key={field.id} className="rounded-xl border p-3">
                <div className="flex flex-col gap-2">
                  <Badge size={null} variant="default">
                    <Icon icon={mapFieldTypeIcon(field.type)} size={IconSize.xxs} /> {field.label}
                  </Badge>
                  <ExpandableContent content={field.value as string} />
                </div>
              </div>
            ))
          ) : (
            <div className="text-sm text-slate-500 p-2">This extension action doesn't have any fields configured.</div>
          )}
        </div>
      )}
      {activeTab === 'settings' && (
        <div key="settings" className="flex flex-col gap-2 w-full">
          {settings.length > 0 ? (
            settings.map(({ label, value }) => (
              <div key={label} className="rounded-xl border p-3">
                <div className="flex flex-col gap-2">
                  <div className="text-sm font-medium text-gray-900">{label}</div>
                  <div className="text-sm text-gray-800 bg-slate-50 p-2 border border-slate-200 wrap-break-word">
                    <p className="break-all">{value}</p>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-sm text-slate-500 p-2">
              This extension action doesn't have any settings configured.
            </div>
          )}
        </div>
      )}
    </div>
  )
}
